// src/utils/handlers.ts (or wherever fits your structure)

import useUserStore from "./store";

export class Handlers {
  handleClosePasswordDialog = () => {
    const { setShowPasswordDialog } = useUserStore.getState();
    setShowPasswordDialog(false);
  };

  handleOpenPasswordDialog = (callback: () => void) => {
    const { setShowPasswordDialog, setPasswordConfirmCallback } =
      useUserStore.getState();
    setPasswordConfirmCallback(callback);
    setShowPasswordDialog(true);
  };

  handleOpenUnsavedChangesDialogStore = () => {
    const { setShowPasswordDialog } = useUserStore.getState();
    setShowPasswordDialog(false);
  };

  handleModalClose = () => {
    const { setAddModal, setCurrentPassword } = useUserStore.getState();
    setAddModal(false);
    setCurrentPassword(null);
  };

  validatePassword = (password: string, confirmPassword: string) => {
    const setPasswordValid = useUserStore.getState().setPasswordValid;

    const minLength = password.length >= 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const passwordsMatch = password === confirmPassword;

    setPasswordValid({
      minLength,
      hasUppercase,
      hasLowercase,
      hasSpecialChar,
      hasNumber,
      passwordsMatch,
    });


  };

  handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, confirmPassword: string) => {
    const { setNewPassword } = useUserStore.getState();
    const value = e.target.value;
    setNewPassword(value);
    this.validatePassword(value, confirmPassword);
  };

  handleConfirmPasswordChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    newPassword: string
  ) => {
    const { setConfirmPassword } = useUserStore.getState();
    const value = e.target.value;
    setConfirmPassword(value);
    this.validatePassword(newPassword, value);
  };


  handleClickShowPassword = () => {
    const { setShowNewPassword, showNewPassword } = useUserStore.getState();
    setShowNewPassword(!showNewPassword);
  };

  handleClickShowConfirmPassword = () => {
    const { setShowConfirmPassword, showConfirmPassword } = useUserStore.getState();
    setShowConfirmPassword(!showConfirmPassword);
  };

  handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  }

  handleOpenConfirmationPasswordModal = () => {
    const { setAddModal } = useUserStore.getState();
    setAddModal(true);
  };


}
